import { render, staticRenderFns } from "./DiagnosisInfo.vue?vue&type=template&id=67ce289a&scoped=true"
import script from "./DiagnosisInfo.vue?vue&type=script&lang=js"
export * from "./DiagnosisInfo.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisInfo.vue?vue&type=style&index=0&id=67ce289a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce289a",
  null
  
)

export default component.exports